import moment from 'moment-timezone'
import { DB_DATETIME_FORMAT } from '../consts'

export const isPartVisible = (part) =>
  part.options &&
  part.options.display &&
  part.options.display.range &&
  part.options.display.range[0] &&
  part.options.display.range[0].date
    ? getPartDisplay(part)
    : true

/* LOGIQUE GÉNÉRALE
  Dans l'admin, on save, on save la date time en string et le timezone en string
  Dans le visit, on fait les dates avec les tz, et on fait le user en localtz

/**
 * takes the timestamps and return moment objects allterned if allDay
 * @param {array of integer/timestamp} range
 * @param {bool} allDay
 */
export const getRangeDates = (range, allDay) => {
  const startDate = moment.tz(range[0].date, DB_DATETIME_FORMAT, range[0].timezone)
  const endDate = moment.tz(range[1].date, DB_DATETIME_FORMAT, range[1].timezone)

  if (allDay) {
    startDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    endDate.set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
  }

  return [startDate, endDate]
}

/**
 * return moment object with only the time set
 * @param {Moment} dateTime
 */
const timeOnly = (dateTime) =>
  moment.tz({ h: dateTime.hours(), m: dateTime.minutes() }, dateTime.tz() || moment.tz.guess())

/**
 * compare times only (ignore dates)
 * @param {Array of moment} dates
 * @param {integer/timestamp} todayString will fallback on 'now'
 */
export const isInTimeRange = (dates, todayString) => {
  const [startDate, endDate] = dates
  const today = todayString ? moment(todayString, DB_DATETIME_FORMAT) : moment() // p-e pas regenerer une a chaque fois
  return timeOnly(today).isBetween(timeOnly(startDate), timeOnly(endDate), 'minutes', '[)')
}

/**
 * @param {Moment} date
 */
const isWeekDay = (date) => !(date.day() === 0 || date.day() === 6) // return is not weekend

/**
 * @param {Array of moment} dates
 * @param {string} repeat
 * @param {bool} allDay
 * @param {Moment} todayString will fallback on 'now'
 */
export const getIsTodayInRange = (dates, repeat, allDay, todayString) => {
  const [startDate, endDate] = dates

  const today = todayString ? moment(todayString, DB_DATETIME_FORMAT) : moment()

  switch (repeat) {
    case 'weekdays': // timeRange répété tous les jours de la semaine
      return isWeekDay(today) && isInTimeRange(dates, todayString) // TODO: todayString??

    case 'weekends': // timeRange répété tous les jours de fds
      if (isWeekDay(today)) {
        return false
      }
      if (allDay) {
        return true
      }
      return isInTimeRange(dates, todayString)

    case 'daily': // timeRange répété tous les jours // TODO: is today after start.
      return !endDate || allDay || isInTimeRange(dates, todayString)

    case 'weekly': // dayTimeRange répété a toute les semaines
      return isInWeeklyRange(dates, today, allDay)

    case 'monthlyDay': // dateTimeRange répété a tous les mois
      return isInMonthlyRange(dates, today, allDay)

    case 'annuallyDay': // dateTimeRange répété a tous les ans
      const isSameYear = dates[0].year() === dates[1].year()
      dates[0].set('year', today.year())
      dates[1].set('year', today.year())
      if (isSameYear) {
        return today.isBetween(dates[0], dates[1], 'minutes', '[]')
      }
      // if not the same year, compare from start of year or end of year.
      const startOfYear = moment().set({
        year: today.year(),
        month: 0,
        date: 1,
        hour: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 1,
      })
      const endOfYear = moment().set({
        year: today.year(),
        month: 12,
        date: 31,
        hour: 23,
        minutes: 59,
        seconds: 59,
        milliseconds: 99,
      })
      return (
        today.isBetween(dates[0], endOfYear, 'minutes', '[]') ||
        today.isBetween(startOfYear, dates[1], 'minutes', '[]')
      )

    default:
      return today.isBetween(startDate, endDate)
  }
}

/**
 *
 * @param {Object Part (from a card)} part
 * @param {integer/timestamp} todayString will fallback on 'now'
 */
export const getPartDisplay = (part, todayString) => {
  if (!part.options?.display?.range[0]?.date) {
    // no options? no date range? show it!
    return true
  }

  const { rule, range, allDay, repeat } = part.options.display
  const dates = getRangeDates(range, allDay)
  const isTodayInRange = getIsTodayInRange(dates, repeat, allDay, todayString)

  return rule === 'show' || !rule ? isTodayInRange : !isTodayInRange
}

/**
 * @param {Array or Moment} param0
 * @param {Moment} todayDate
 * @param {bool} allDay
 */
const isInWeeklyRange = ([startDate, endDate], todayDate, allDay) => {
  const NBR_DAYS_IN_WEEK = 7 - 1
  const possibleDays = [startDate.day(), endDate.day()]
  const todayDay = todayDate.day()

  if (possibleDays[0] < possibleDays[1]) {
    for (let i = possibleDays[0] + 1; i < possibleDays[1]; i++) {
      possibleDays.push(i)
    }
  } else if (possibleDays[1] < possibleDays[0]) {
    for (let i = NBR_DAYS_IN_WEEK; i > possibleDays[0]; i--) {
      possibleDays.push(i)
    }
    for (let i = 0; i < possibleDays[1]; i++) {
      possibleDays.push(i)
    }
  }

  const isAPossibleDay = possibleDays.some((current) => current === todayDay)

  if (!isAPossibleDay) {
    return false
  }
  if (allDay) {
    return true
  }

  // validate if is after begeningtime of startDate
  if (todayDay === possibleDays[0]) {
    const dates = [startDate, moment(endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 999 })]
    return isInTimeRange(dates, todayDate)
  } else if (todayDay === possibleDays[1]) {
    // validate if is before endtime of endDate
    const dates = [moment(endDate).set({ hour: 0, minute: 0, second: 0, millisecond: 1 }), endDate]
    return isInTimeRange(dates, todayDate)
  } else {
    return true
  }

  return 'fuck'
}

// TODO: refactor probablement plus simple si on utilise la logique du anually...
/**
 * @param {Array or Moment} param0
 * @param {Moment} todayDate
 * @param {bool} allDay
 */
const isInMonthlyRange = ([startDate, endDate], todayDate, allDay) => {
  const possibleDays = [startDate.date(), endDate.date()]
  const todayDay = todayDate.date()

  if (possibleDays[0] < possibleDays[1]) {
    for (let i = possibleDays[0] + 1; i < possibleDays[1]; i++) {
      possibleDays.push(i)
    }
  } else if (possibleDays[1] < possibleDays[0]) {
    for (let i = endDate.daysInMonth(); i > possibleDays[0]; i--) {
      possibleDays.push(i)
    }
    for (let i = 1; i < possibleDays[1]; i++) {
      possibleDays.push(i)
    }
  }

  const isAPossibleDay = possibleDays.some((current) => current === todayDay)

  if (!isAPossibleDay) {
    return false
  }
  if (allDay) {
    return true
  }

  if (todayDay === possibleDays[0]) {
    const dates = [startDate, moment(endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 999 })]
    return isInTimeRange(dates, todayDate)
  } else if (todayDay === possibleDays[1]) {
    // validate if is before endtime of endDate
    const dates = [moment(endDate).set({ hour: 0, minute: 0, second: 0, millisecond: 1 }), endDate]
    return isInTimeRange(dates, todayDate)
  } else {
    return true
  }
}
